import { createEntityAdapter } from '@reduxjs/toolkit';
import { PronoGameListItemDTO } from '../types';

export const pronoGamesAdapter = createEntityAdapter<PronoGameListItemDTO>({
  selectId: game => game.id,
  sortComparer: (a, b) => b.dateCreated.localeCompare(a.dateCreated),
});
